import { render, staticRenderFns } from "./Show404.vue?vue&type=template&id=61d82e26&"
import script from "./Show404.vue?vue&type=script&lang=js&"
export * from "./Show404.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports